import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type { ContentStatus } from '../constants/ContentStatus.ts';
import { getQuerySingleContentStatusArrayVariable } from '../utils/getQuerySingleContentStatusArrayVariable.ts';
import useContentClassificationContentDataClassificationQuery, {
	type useContentClassificationContentDataClassificationQuery$data,
	type useContentClassificationContentDataClassificationQuery$variables,
} from '../hooks/__generated__/useContentClassificationContentDataClassificationQuery.graphql.ts';

export function preloadContentDataClassification(contentId: string, contentStatus: ContentStatus) {
	return query<
		useContentClassificationContentDataClassificationQuery$data,
		useContentClassificationContentDataClassificationQuery$variables
	>({
		query: useContentClassificationContentDataClassificationQuery,
		variables: {
			contentId,
			lowerCaseContentStatusArray: getQuerySingleContentStatusArrayVariable([contentStatus]),
		},
	});
}
